import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

const artikelen = [
  {
    t: "1. Definities",
    p: "LevelLeven: de programma's (START en VERDER) en trainingen die LevelLeven aanbiedt, een concept van OutsideTen. Opdrachtgever: de gemeente, overheidsorganisatie, werkgever of andere rechtspersoon die met LevelLeven een overeenkomst aangaat. Deelnemer: de natuurlijke persoon die deelneemt aan het programma. Training: een op de LevelLeven-methodiek gebaseerd opleidingsprogramma voor professionals.",
  },
  {
    t: "2. Toepasselijkheid",
    p: "Deze voorwaarden zijn van toepassing op alle aanbiedingen, offertes en overeenkomsten tussen LevelLeven en opdrachtgever, tenzij schriftelijk anders overeengekomen.",
  },
  {
    t: "3. Overeenkomst en pilotperiode",
    p: "Een overeenkomst komt tot stand na schriftelijke bevestiging. Voor pilots geldt een minimale looptijd van één cohort (12 weken START), tenzij anders overeengekomen. LevelLeven levert tussen- en eindrapportage per cohort.",
  },
  {
    t: "4. Prijzen en betaling",
    p: "Alle prijzen zijn exclusief BTW, tenzij anders vermeld. Betaling geschiedt binnen 30 dagen na factuurdatum. Bij overheidsopdrachtgevers gelden de standaard voorwaarden voor publiekrechtelijke betalingen.",
  },
  {
    t: "5. Annulering en wijzigingen",
    p: "Annulering door de opdrachtgever binnen 4 weken voor aanvang van het programma of training kan leiden tot een annuleringsvergoeding van maximaal 50% van de overeengekomen prijs. Wijzigingen in groepsomvang worden in redelijkheid geaccommodeerd.",
  },
  {
    t: "6. Verplichtingen deelnemer",
    p: "Deelnemers verplichten zich tot aanwezigheid op de tweewekelijkse bijeenkomsten en de driedaagse blokken. Bij herhaalde afwezigheid volgt overleg met de casemanager of opdrachtgever.",
  },
  {
    t: "7. Aansprakelijkheid",
    p: "LevelLeven is niet aansprakelijk voor indirecte schade of gevolgschade die voortvloeit uit deelname aan het programma of de trainingen. De maximale aansprakelijkheid is beperkt tot het factuurbedrag van de betreffende opdracht.",
  },
  {
    t: "8. Intellectueel eigendom",
    p: "Het LevelLeven-programma, het LevelLeven Transitiemodel, de methodiek en alle documentatie (waaronder brochures, whitepapers en handleidingen) zijn eigendom van LevelLeven / OutsideTen. Overname of publicatie zonder schriftelijke toestemming is niet toegestaan.",
  },
  {
    t: "9. Vertrouwelijkheid",
    p: "Partijen bewaren de vertrouwelijkheid van gegevens die zij in het kader van de opdracht ontvangen. Rapportages aan de gemeente vinden geanonimiseerd plaats waar mogelijk, met instemming van de deelnemer.",
  },
  {
    t: "10. Toepasselijk recht",
    p: "Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement van LevelLeven / OutsideTen.",
  },
];

export default function Voorwaarden() {
  usePageMeta({
    title: "Algemene voorwaarden, LevelLeven",
    description: "Algemene voorwaarden voor programma's, trainingen en samenwerking met LevelLeven.",
  });
  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Algemene voorwaarden</SectionLabel>
          <h1 className="font-heading text-5xl sm:text-6xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
            Werkbare afspraken,{" "}
            <span className="italic text-[#E06B3F]">helder vastgelegd</span>.
          </h1>
          <p className="mt-6 text-[#7A8276] italic text-sm">
            Startversie. Wordt in overleg met opdrachtgevers en juridisch advies verder ingevuld.
          </p>
        </div>
      </section>
      <section className="pb-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16 space-y-10">
          {artikelen.map((a) => (
            <div key={a.t} className="border-t border-[#E5E1D8] pt-8">
              <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">{a.t}</h2>
              <p className="text-[#4A5D4E] leading-relaxed font-light">{a.p}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
